import { writable } from "svelte/store"

/**
 * Function converts the json format data into template data
 * @param {Object} obj - represents the json data to be converted
 * @param {String} parent - parent is the optional parameter and its represents the parent of the key in object
 * @returns {Template}
 */
export const jsonToTemplate = (obj, parent = "") => {
  try {
    let template = []
    let keys = Object.keys(obj)
    for (let i = 0; i < keys.length; i++) {
      let templateObject = {}
      templateObject.parent = parent
      templateObject.key = keys[i]
      if (typeof obj[keys[i]] != "object") {
        templateObject.value = obj[keys[i]]
        templateObject.id = `${parent}.${keys[i]}`
        template.push(templateObject)
      } else {
        let nestedTemplate = jsonToTemplate(obj[keys[i]], parent ? `${parent}.${keys[i]}` : keys[i])
        template = [...template, ...nestedTemplate]
      }
    }
    return template
  } catch (error) {
    // console.error("invalid JSON")
    // console.error(error)
    throw new Error("invalid JSON")
  }
}

/**
 * Function converts the template data into json format
 * @param {Template} template template data to be converted
 * @param {Object} parentJSON parentJson is the optional parameter and the converted json data embeds in the parentjson
 * @returns {Object}
 */
export const templateToJSON = (template, parentJSON = {}) => {
  try {
    for (let i = 0; i < template.length; i++) {
      if (template[i].parent.indexOf(".") < 0) {
        if (!parentJSON[template[i].parent]) {
          parentJSON[template[i].parent] = {}
        }
        parentJSON[template[i].parent][template[i].key] = template[i].value
      } else {
        let lineage = template[i].parent.split(".")
        let currentParent = lineage[0]

        let tempTemplateObj = {}
        tempTemplateObj.key = template[i].key
        tempTemplateObj.value = template[i].value
        tempTemplateObj.parent = lineage.slice(1, lineage.length).join(".")

        if (!parentJSON[currentParent]) {
          parentJSON[currentParent] = {}
        }
        parentJSON[currentParent] = {
          ...templateToJSON([tempTemplateObj], parentJSON[currentParent]),
        }
      }
    }
    return parentJSON
  } catch (error) {
    // console.error(error)
    throw error
  }
}

/**
 * @typedef {Object} Template - represents the template form data converted from the json format
 * @type {Object}
 * represents the template form data converted from the json format
 *
 * @property {string} id - Id of the object
 * @property {string} key - indicates the value placed in the key of the object
 * @property {string} value - indicates the value corresponding to its key value
 * @property {string} parent - parent name of the nested object
 */
/**
 * @type {import("svelte/store").Writable<Array<template>>}
 */

const template = writable([])

export default template
